import { render } from "./ReportDetails.vue?vue&type=template&id=5df1c7ba&scoped=true"
import script from "./ReportDetails.vue?vue&type=script&lang=js"
export * from "./ReportDetails.vue?vue&type=script&lang=js"

import "./ReportDetails.vue?vue&type=style&index=0&id=5df1c7ba&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5df1c7ba"]])

export default __exports__